import { render, staticRenderFns } from "./VarietyListHeader.vue?vue&type=template&id=5765b957&scoped=true&"
import script from "./VarietyListHeader.vue?vue&type=script&lang=ts&"
export * from "./VarietyListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VarietyListHeader.vue?vue&type=style&index=0&id=5765b957&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765b957",
  null
  
)

export default component.exports